/*

example:
<!--
<s-add-encrypted-staff
  :newOpenersEuid.sync="newOpenersEuid"
/>
-->
*/

<template>
  <div v-if="$config.isShowEncrypted">
    <div class="caption grey--text">
      <!-- 可開啟密件人員 -->
      {{ $t('eDocInternal.encryptedFileViewerStaff') }}
    </div>
    <div
      class="text-body-2 pa-2 grey lighten-4 grey--text text--darken-2 rounded"
      style="border-bottom: 1px solid #333"
    >
      {{ openers }}
    </div>
    <s-search-staff-muti
      v-model="staffEuidList"
      :label="$t('eDocInternal.encryptedFileViewerStaff.add')"
      @dataChange="staffObjList = $event"
    />
    <s-encrypt-password-dialog ref="passwordDialog" />
  </div>
</template>

<script>
import SSearchStaffMuti from '@/components/SSearchStaffMuti.vue'
import SEncryptPasswordDialog from '@/components/SEncryptPasswordDialog.vue'
import stringUtil from '@/utils/stringUtil'
import { mapGetters, mapMutations } from 'vuex'
import { commonComponentModule } from '@/store/moduleName.js'

export default {
  components: {
    SSearchStaffMuti,
    SEncryptPasswordDialog
  },
  props: {
    openerList: {
      type: Array,
      required: true
    }
  },
  data: function () {
    return {
      staffEuidList: [],
      staffObjList: []
      // decryptedFileKey: null
    }
  },
  computed: {
    ...mapGetters(commonComponentModule, ['decryptedFileKey']),

    openers () {
      let result = ''
      this.openerList.forEach(opener => {
        if (!stringUtil.isFieldBlank(result)) {
          result = result + ', '
        }
        let blank = ''
        if (!stringUtil.isFieldBlank(opener.chinName) && !stringUtil.isFieldBlank(opener.portName)) {
          blank = ' '
        }
        result = result + stringUtil.nvl(opener.chinName, '') + blank + stringUtil.nvl(opener.portName, '')
      })
      return result
    }
  },
  watch: {
    staffEuidList: {
      handler: async function (val) {
        if (val && val.length) {
          await this.inputPassword()
        }
        if (this.decryptedFileKey) {
          this.$emit('update:newOpenersEuid', val)
          this.$emit('update:newOpenersObj', this.staffObjList)
        }
      }
    },
    deep: true
  },
  methods: {
    ...mapMutations(commonComponentModule, ['setDecryptedFileKey']),

    inputPassword: async function () {
      let deFileKey
      if (!this.decryptedFileKey) {
        deFileKey = await this.$refs.passwordDialog.getPassword().catch(() => {
          console.log('user click cancel')
          this.staffEuidList = []
        })
        this.setDecryptedFileKey(deFileKey)
      }
    },
    clear () {
      this.staffEuidList = []
      this.staffObjList = []
      this.$store.commit(commonComponentModule + '/clearSecurityFileKeys')
    }
  }
}
</script>
